import { useCallback, useEffect } from "react";
import MenuOptions from "./sections/MenuOptions";
import Layout from "components/layout/Layout";
import { useNavigate } from "react-router-dom";
import { FormattedMessage, useIntl } from "react-intl";
import LogoutButton from "components/button/LogoutButton";
import history from "history/browser";
import TrainTicket from "components/reservation/OrderThumbnail";
import PersonalInfoSettingSection from "./sections/PersonalInfoSettingSection";
import { useAppSelector } from "app/hooks";
import MyPointsSection from "./sections/MyPointsSection";
import { ProviderUtils } from "utils/providerUtils";
import OrderSkeleton from "components/skeleton/OrderSkeleton";
import { Divider } from "@mui/material";
import SectionHeaders from "./components/SectionHeaders";
import useFetchOrderInfo from "hooks/orderInfos/useFetchOrderInfo";
import { getContextualUrl, getIsJTRPage } from "utils/navigation";

const NUMBER_OF_RECENT_ORDERS = 4;

const PersonalInfoPage = () => {
  const isJTRPage = getIsJTRPage();
  const { recentOrders } = useAppSelector((state) => state.myOrders);
  let filteredOrders = recentOrders.filter(
    (order) => order.orderStatus !== "PENDING"
  );

  // 하나카드
  // 일본 상품 페이지에서 최근 주문내역 조회 시, 일본 상품만 조회
  // KTX 상품 페이지에서 최근 주문내역 조회 시, KTX 상품 조회
  if (ProviderUtils.isHanacard) {
    filteredOrders = filteredOrders.filter(
      (order) => order.productType === (isJTRPage ? "TRAVEL" : "TRAIN")
    );
  }

  const [isFetching, fetchOrderInfos] = useFetchOrderInfo();

  const intl = useIntl();
  const navigate = useNavigate();

  // 이전 페이지가 JTR 관련 페이지인 경우, 뒤로 가기 시 Activity Home으로 redirect
  const backToMain = useCallback(() => {
    navigate(getContextualUrl("/"), { replace: true });
  }, [navigate]);

  const moveToOrderHistory = () => {
    navigate(getContextualUrl("/order-history"));
  };
  useEffect(() => {
    fetchOrderInfos();

    const historyEvent = history.listen(({ action }) => {
      if (action === "POP") {
        backToMain();
      }
    });
    return historyEvent;
  }, [backToMain, fetchOrderInfos]);

  return (
    <Layout
      onBack={backToMain}
      text={intl.formatMessage({ id: "user.myInfo" })}
    >
      <section className="space-y-4">
        <PersonalInfoSettingSection />
        <MyPointsSection />
        {/* {ProviderUtils.provider?.provider === "lottetest" && (
          <TravelPackCard text={"트래블팩 구독하고 1천원 적립금 받아요"} />
        )} */}

        <Divider />

        {/* 최근 주문내역 */}
        <div className="space-y-2">
          <SectionHeaders
            header={<FormattedMessage id="user.recentOrders" />}
            handleClick={moveToOrderHistory}
            buttonText={<FormattedMessage id="user.more" />}
          />
          <div className="space-y-2">
            {isFetching ? (
              <OrderSkeleton number={NUMBER_OF_RECENT_ORDERS} />
            ) : (
              filteredOrders
                .splice(0, NUMBER_OF_RECENT_ORDERS)
                .map((order, index) => (
                  <TrainTicket key={index} order={order} />
                ))
            )}
          </div>
        </div>

        <MenuOptions />
        {ProviderUtils.loginAvailable && <LogoutButton />}
      </section>
    </Layout>
  );
};

export default PersonalInfoPage;
